module.exports = __webpack_public_path__ + "img/logo-pinterest.28871b68.svg";